<template>
  <b-row align-h="center">
    <b-col :sm="cardSize.sm" :md="cardSize.md" :lg="cardSize.lg" :xl="cardSize.xl" class="vld-parent">
      <loading :active.sync="loadingOverlayActive" :can-cancel="false" />

      <b-card class="mb-2 form-card">
        <template #header class="card-header">
          <span class="small-link">
            <a href="/ressources/entreprise/guide-inscription.mp4" target="_blank">Guide Vidéo</a>
            <!-- | <a href="/ressources/entreprise/guide.pdf" target="_blank">Guide PDF</a> -->
          </span>
          <h4 class="my-2">Signature du formulaire</h4>
        </template>

        <b-card-body>
          <div v-if="!convention">
            <b-spinner label="Chargement..." class="d-block mx-auto" />
          </div>
          <form-wizard
            v-else
            @on-change="onChangeStep"
            :startIndex="0"
            title=""
            subtitle=""
            :nextButtonText="nextButtonText"
            backButtonText="Précédent"
            finishButtonText="Signer"
            stepSize="xs"
            color="#3F51B5"
            ref="formWizard"
          >
            <tab-content title="💡 Informations">
              <b-form>
                <b-row>
                  <b-col sm="12" class="mb-2">
                    <b-alert show variant="info">
                      <p>
                        Vous avez été invité par <strong>{{ formatCivilite(convention.demandeur.civilite) }} {{ convention.demandeur.prenom }} {{ convention.demandeur.nom }} ({{ convention.demandeur.email }})</strong> à signer le formulaire suivant, 
                        ayant pour finalité la prise de votre consentement à recevoir les actes signifiés par voie dématérialisée par un Commissaire de Justice, conformément aux dispositions des 
                        articles 653, 662-1, 663 et 664-1 du code de procédure civile et du Décret n° 2021-1625 du 10 décembre 2021.
                      </p>
                    </b-alert>
                  </b-col>
                  <b-col sm="12">
                    <h4>
                      Établissement<br />
                      <small class="text-muted">Le consentement vaudra pour l'ensemble des établissements (siège et succursales)</small>
                    </h4>
                    <b-table
                        striped
                        hover
                        :fields="[ { key: 'field' }, { key: 'value' } ]"
                        :items="etablissementTableItems"
                        thead-class="hidden_header"
                    />

                    <h4 class="mt-4">Consentements</h4>
                    <h6 v-if="!convention.consentements">Aucun nouveau consentement</h6>
                    <div v-else>
                      <div v-for="(consentement, index) in convention.consentements" :key="index">
                        <h6>✔️ {{ consentementTypeToLabel(consentement.type) }}</h6>
                        <b-table
                            striped
                            hover
                            :fields="[ { key: 'field' }, { key: 'value' } ]"
                            :items="[
                                { field: 'Service', value: `${consentement.service.nom.toUpperCase()} (${consentement.service.email.toLowerCase()})` },
                                { field: 'Prénom Nom', value: `${consentement.contactOperationnel.prenom.toUpperCase()} ${consentement.contactOperationnel.nom.toUpperCase()}` },
                                { field: 'Qualité', value: consentement.contactOperationnel.qualite.toUpperCase() },
                                { field: 'Email', value: consentement.contactOperationnel.email.toLowerCase() },
                                { field: 'Tel. Fixe / Tel. Mobile', value: `${consentement.contactOperationnel.telFixe} / ${consentement.contactOperationnel.telMobile}` },
                            ]"
                            thead-class="hidden_header"
                            caption-top
                        >
                          <template #table-caption>Contact opérationnel :</template>
                        </b-table>
                      </div>
                    </div>

                    <!-- <h4 class="mt-4">Signataire</h4>
                    <b-table
                        striped
                        hover
                        :fields="[ { key: 'field' }, { key: 'value' } ]"
                        :items="[
                            { field: 'Civilité', value: convention.signataire.civilite },
                            { field: 'Prénom', value: convention.signataire.prenom.toUpperCase() },
                            { field: 'Nom', value: convention.signataire.nom.toUpperCase() },
                            { field: 'Qualité', value: convention.signataire.qualite.toUpperCase() },
                            { field: 'Email', value: convention.signataire.email.toLowerCase() },
                            { field: 'Téléphone', value: convention.signataire.tel },
                        ]"
                        thead-class="hidden_header"
                    /> -->
                  </b-col>
                </b-row>
              </b-form>
            </tab-content>

            <tab-content title="👤 Signataire (vous-même)" :beforeChange="validateSignatory">
              <b-form @submit.prevent="submitSignatory">
                <b-row>
                  <b-col sm="12" class="mb-2">
                    <div>
                      <b-form-group label="Civilité">
                        <b-form-radio-group
                          v-model="convention.signataire.civilite"
                          :options="[ { text: 'M', value: 'M' }, { text: 'Mme', value: 'MME' }, { text: 'Non-binaire', value: 'NB' } ]"
                          name="civilite-radio"
                        />
                      </b-form-group>
                    </div>
                  </b-col>
                  <b-col sm="12" lg="6" class="mb-2">
                    <b-form-group label="Prénom">
                        <b-form-input class="uppercase-input" v-model="convention.signataire.prenom" placeholder="Prénom*" required />
                    </b-form-group>
                  </b-col>
                  <b-col sm="12" lg="6" class="mb-2">
                    <b-form-group label="Nom">
                        <b-form-input class="uppercase-input" v-model="convention.signataire.nom" placeholder="Nom*" required />
                    </b-form-group>
                  </b-col>
                  <b-col sm="12" lg="6" class="mb-2">
                    <b-form-group label="Qualité">
                        <b-form-input class="uppercase-input" v-model="convention.signataire.qualite" placeholder="Qualité*" required />
                    </b-form-group>
                  </b-col>
                  <b-col sm="12" lg="6" class="mb-2">
                    <b-form-group label="Adresse email">
                    <b-form-input v-model="convention.signataire.email" type="email" placeholder="Adresse email*"   required />
                    </b-form-group>
                  </b-col>
                  <b-col sm="12" lg="6" class="mb-2">
                    <b-form-group label="Téléphone">
                        <b-form-input v-model="convention.signataire.tel" type="tel" placeholder="Téléphone*" required />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
            </tab-content>

            <tab-content title="📂 Justificatifs" :beforeChange="validateAttachments">
              <b-form @submit.prevent="submitAttachments">
                <b-row>
                  <b-col sm="12" lg="6" class="mb-2">
                    <b-form-group>
                      <div style="display: flex;justify-content: space-between;">
                        <label>Justificatif d'identité</label>
                        <b-button size="sm" variant="link" v-b-modal.modal-infos-justificatif-identite>
                          <b-icon icon="info-circle"></b-icon>
                        </b-button>
                        <b-modal id="modal-infos-justificatif-identite" title="Informations supplémentaires" hide-footer>
                          Un justificatif d'identité <strong>en cours de validité</strong> du représentant légal de la personne morale ou de la personne physique ayant reçu pouvoir d'établir la déclaration au nom et pour le compte de la personne morale.
                          <ul>
                            <li>Carte nationale d'identité, ou</li>
                            <li>Passeport, ou</li>
                            <li>Titre de séjour.</li>
                          </ul>
                        </b-modal>
                      </div>

                      <b-card v-if="convention.justificatifIdentite" class="p-0 m-0">
                        ✔️ Justificatif déjà fourni
                      </b-card>
                      <b-form-file
                        v-else
                        v-model="convention.justificatifIdentiteFile"
                        accept="image/jpeg, image/png, application/pdf"
                        placeholder="JPG, PNG, PDF - Max 2Mo"
                        drop-placeholder="Déposez un fichier ici..."
                        @input="e => handleFileUpload('justificatifIdentiteFile', e)"
                        :state="!!convention.justificatifIdentiteFile || !!convention.justificatifIdentite"
                      />
                    </b-form-group>
                  </b-col>
                  
                  <!-- Établissement privé -->
                  <b-col sm="12" lg="6" class="mb-2">
                    <b-form-group>
                      <div style="display: flex;justify-content: space-between;">
                        <label>Mandat de gestion pour délégation des pouvoirs</label>
                        <b-button size="sm" variant="link" v-b-modal.modal-infos-mandat-gestion>
                          <b-icon icon="info-circle"></b-icon>
                        </b-button>
                        <b-modal id="modal-infos-mandat-gestion" title="Informations supplémentaires" hide-footer>
                          Un document émanant du représentant légal ou de l'organe compétent attestant de la capacité de l'auteur de la déclaration à engager la personne morale.
                        </b-modal>
                      </div>

                      <b-card v-if="convention.mandatDelegation" class="p-0 m-0">
                        ✔️ Justificatif déjà fourni
                      </b-card>
                      <b-form-file
                        v-else
                        v-model="convention.mandatDelegationFile"
                        accept="image/jpeg, image/png, application/pdf"
                        placeholder="JPG, PNG, PDF - Max 2Mo"
                        drop-placeholder="Déposez un fichier ici..."
                        @input="e => handleFileUpload('mandatDelegationFile', e)"
                        :state="!!convention.mandatDelegationFile || !!convention.mandatDelegation"
                      />
                    </b-form-group>
                  </b-col>

                  <!-- Établissement de droit public -->
                  <b-col v-if="convention.etablissementType === 'public'" sm="12" lg="6" class="mb-2">
                    <b-form-group>
                      <div style="display: flex;justify-content: space-between;">
                        <label>Document attestant de la capacité à engager la personne morale</label>
                        <b-button size="sm" variant="link" v-b-modal.modal-infos-document-capacite>
                          <b-icon icon="info-circle"></b-icon>
                        </b-button>
                        <b-modal id="modal-infos-document-capacite" title="Informations supplémentaires" hide-footer>
                          Un document émanant de l'organe compétent attestant de la capacité de l'auteur de la déclaration à engager la personne morale.
                        </b-modal>
                      </div>

                      <b-card v-if="convention.documentCapacite" class="p-0 m-0">
                        ✔️ Justificatif déjà fourni
                      </b-card>
                      <b-form-file
                        v-else
                        v-model="convention.documentCapaciteFile"
                        accept="image/jpeg, image/png, application/pdf"
                        placeholder="JPG, PNG, PDF - Max 2Mo"
                        drop-placeholder="Déposez un fichier ici..."
                        @input="e => handleFileUpload('documentCapaciteFile', e)"
                        :state="!!convention.documentCapaciteFile || !!convention.documentCapacite"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col sm="12" lg="6" class="mb-2">
                    <b-form-group>
                      <div style="display: flex;justify-content: space-between;">
                        <label>Justificatif d'immatriculation</label>
                        <b-button size="sm" variant="link" v-b-modal.modal-infos-justificatif-immatriculation>
                          <b-icon icon="info-circle"></b-icon>
                        </b-button>
                        <b-modal id="modal-infos-justificatif-immatriculation" title="Informations supplémentaires" hide-footer>
                          <ul>
                            <li>
                              Pour les personnes morales immatriculées au registre du commerce et des sociétés :
                              <ul>
                                <li>Extrait Kbis ou Lbis original du registre du commerce et des sociétés de moins de trois mois</li>
                              </ul>
                            </li>
                            <li>
                              Pour les autres :
                              <ul>
                                <li>Extrait original d'immatriculation au répertoire des métiers de moins de trois mois, ou</li>
                                <li>Journal d'annonces légales de mois de deux ans mentionnant le nom du représentant légal et l'adresse du siège de la personne morale, ou</li>
                                <li>Statuts ou toute autre pièce justificative attestant de l'existence légale de la personne morale et faisant apparaître le nom de son représentant légal, l'adresse de son siège, ainsi que la preuve de la déclaration auprès des organismes compétents.</li>
                              </ul>
                            </li>
                          </ul>
                        </b-modal>
                      </div>

                      <b-card v-if="convention.justificatifImmatriculation" class="p-0 m-0">
                        ✔️ Justificatif déjà fourni
                      </b-card>
                      <b-form-file
                        v-else
                        v-model="convention.justificatifImmatriculationFile"
                        accept="image/jpeg, image/png, application/pdf"
                        placeholder="JPG, PNG, PDF - Max 2Mo"
                        drop-placeholder="Déposez un fichier ici..."
                        @input="e => handleFileUpload('justificatifImmatriculationFile', e)"
                        :state="!!convention.justificatifImmatriculationFile || !!convention.justificatifImmatriculation"
                      />
                    </b-form-group>
                  </b-col>
                  <b-col sm="12" lg="6" class="mb-2">
                    <b-form-group>
                      <div style="display: flex;justify-content: space-between;">
                        <label>Justificatif de l'adresse du siège</label>
                        <b-button size="sm" variant="link" v-b-modal.modal-infos-justificatif-adresse-siege>
                          <b-icon icon="info-circle"></b-icon>
                        </b-button>
                        <b-modal id="modal-infos-justificatif-adresse-siege" title="Informations supplémentaires" hide-footer>
                          L'original ou la copie de l'un des justificatifs de l'adresse du siège de la personne morale suivants :
                          <ul>
                            <li>Titre de propriété, ou</li>
                            <li>Quittance de loyer de moins de trois mois, ou</li>
                            <li>Facture (de gaz, d'électricité, de téléphone… ) de moins de trois mois.</li>
                          </ul>
                        </b-modal>
                      </div>

                      <b-card v-if="convention.justificatifAdresseSiege" class="p-0 m-0">
                        ✔️ Justificatif déjà fourni
                      </b-card>
                      <b-form-file
                        v-else
                        v-model="convention.justificatifAdresseSiegeFile"
                        accept="image/jpeg, image/png, application/pdf"
                        placeholder="JPG, PNG, PDF - Max 2Mo"
                        drop-placeholder="Déposez un fichier ici..."
                        @input="e => handleFileUpload('justificatifAdresseSiegeFile', e)"
                        :state="!!convention.justificatifAdresseSiegeFile || !!convention.justificatifAdresseSiege"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
            </tab-content>
            
            <tab-content title="🖋️ Signature" :beforeChange="validateAndSendOtp">
                <vue-pdf-app v-if="showPdf" :config="pdfViewerConfig" ref="pdfViewer" :page-number="pdfPage" class="mb-2" style="height: 80vh" :pdf="pdfUrl" />

                <h5 class="mt-2">En cliquant sur « Valider », vous recevrez un code de vérification par email</h5>
            </tab-content>
            <tab-content title="🔐 Vérification" :beforeChange="validateOtp">
                <h4 class="text-center">
                    Veuillez saisir le code de sécurité envoyé à l'adresse <strong>{{ convention.signataire.email }}</strong>
                </h4>
                <div class="mx-auto mb-2" style="max-width: 300px;">
                    <input
                        type="text"
                        class="form-control"
                        v-model="otp"
                        placeholder="Code de sécurité"
                        disabled
                    />
                    <CodeKeyboard @pressed="otp = $event" :selfValue="otp" />
                </div>
            </tab-content>

          </form-wizard>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {FormWizard, TabContent} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import axios from '@axios'
import VuePdfApp from "vue-pdf-app"
// import this to use default icons for buttons
import "vue-pdf-app/dist/icons/main.css"
import CodeKeyboard from "@/components/CodeKeyboard"

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: "PreRegistration",
  components: {
    FormWizard,
    TabContent,
    VuePdfApp,
    CodeKeyboard,
    Loading,
  },
  data() {
    return {
        pdfViewerConfig: {
          secondaryToolbar: false,
          toolbar: {
            toolbarViewerRight: {
              presentationMode: true,
              openFile: false,
              print: false,
              download: false,
              viewBookmark: false,
            },
          },
        },
        nextButtonText: "Suivant",
        hash: null,
        otp: "",
        pdfPage: 1,
        showPdf: false,
        convention: null,
        cardSize: {
            sm: 12,
            md: 10,
            lg: 9,
            xl: 8,
        },
        loadingOverlayActive: false,
    }
  },
  mounted() {
      this.$router.onReady(() => {
          this.hash = this.$route.params.hash
          this.fetchConvention()
      })
  },
  computed: {
    etablissementTableItems() {
      if (!this.convention || !this.convention.etablissement) return [];
      
      const items = [];
      
      // Conditionally add SIREN if available
      if (this.convention.etablissement.siren) {
        items.push({
          field: 'SIREN',
          value: this.convention.etablissement.siren.replace(/(\d{3})(\d{3})(\d{3})/, '$1 $2 $3')
        });
      }
      
      // Conditionally add RNA if available
      if (this.convention.etablissement.rna) {
        items.push({
          field: 'Numéro RNA',
          value: this.convention.etablissement.rna
        });
      }
      
      // Conditionally add RNC if available
      if (this.convention.etablissement.rnc) {
        items.push({
          field: 'Numéro RNC',
          value: this.convention.etablissement.rnc
        });
      }
      
      // Add other fields
      items.push(
        {
          field: 'Forme juridique',
          value: this.convention.etablissement.formeJuridique ? this.convention.etablissement.formeJuridique.toUpperCase() : ''
        },
        {
          field: 'Raison sociale',
          value: this.convention.etablissement.raisonSociale
        },
        {
          field: 'Adresse',
          value: this.convention.etablissement.adresse.toUpperCase()
        },
        {
          field: 'Code postal',
          value: this.convention.etablissement.codePostal
        },
        {
          field: 'Ville',
          value: this.convention.etablissement.ville.toUpperCase()
        }
      );
      
      return items;
    },
    pdfUrl() {
      return `${process.env.VUE_APP_API_URL}/conventions/${this.hash}/preview-pdf`;
    }
  },
  methods: {
    formatCivilite(civilite) {
      switch(civilite) {
        case 'M':
          return 'M.'
        case 'MME':
          return 'Mme'
        case 'NB':
          return 'Mx.'
        default:
          return civilite || ''
      }
    },
    consentementTypeToLabel(type) {
      if (type == "PM") {
        return "Je donne mon consentement pour tout acte lié à l'activité de mon entreprise";
      } else if (type == "PMSR") {
        return "Je souhaite donner de manière distincte mon consentement à recevoir les actes de la procédure de saisie des rémunérations";
      } else {
        return "";
      }
    },
    setCardSizeSmall() {
      this.cardSize = { sm: 12, md: 10, lg: 9, xl: 8 }
    },
    setCardSizeLarge() {
      this.cardSize = { sm: 12, md: 12, lg: 10, xl: 10 }
    },
    onChangeStep(prev, current) {
      if (current === 3) {
        // this.setCardSizeLarge()
        this.showPdf = true
        this.nextButtonText = "Valider"
      } else {
        // this.setCardSizeSmall()
        this.showPdf = false
        this.nextButtonText = "Suivant"
      }

      return false
    },
    fetchConvention() {
        axios.get(`/conventions/${this.hash}`)
            .then(({ data }) => {
                console.log(data)
                this.convention = data
                if (this.convention.dateSignaturePm) {
                  this.$toast.open({ message: 'Convention déjà signée', type: 'error' })
                  this.$router.push({ name: 'entrepriseLogin '})
                }
            })
            .catch(() => {
                this.$toast.open({ message: 'Convention introuvable', type: 'error' })
                this.$router.push({ name: 'entrepriseLogin '})
            })
    },
    handleFileUpload(file, e) {
        console.log(e)
        if (!e) return

        if (e.size > 2 * 1000000) {
            this.$toast.open({ message: 'Taille max 2Mo', type: 'error' })
            this.convention[file] = null
        } else if (!['application/pdf', 'image/jpeg', 'image/png'].includes(e.type)) {
            this.$toast.open({ message: 'Fichiers PDF, JPG et PNG autorisés uniquement', type: 'error' })
            this.convention[file] = null
        }
    },
    validateContact() {
        return true
    },
    submitContact() {
      if (this.validateContact()) {
        this.$refs.formWizard.nextTab()
      }
    },
    async validateSignatory() {
      let message = null
      if (!this.convention.signataire.civilite) message = "Civilité requise"
      else if (!this.convention.signataire.prenom) message = "Prénom requis"
      else if (!this.convention.signataire.nom) message = "Nom requis"
      else if (!this.convention.signataire.qualite) message = "Qualité requise"
      else if (!this.convention.signataire.email) message = "Email requis"
      else if (!this.convention.signataire.tel) message = "Téléphone requis"

      if (message) {
        this.$toast.open({ message, type: 'error' })
        return false
      } else {
        try {
            const convention = { signataire: this.convention.signataire }
            await axios.put(`/conventions/${this.hash}`, convention)
            return true
        } catch (err) {
            console.error(err)
            return false
        }
      }
    },
    submitSignatory() {
      if (this.validateSignatory()) {
        this.$refs.formWizard.nextTab()
      }
    },
    async validateAttachments() {
        const toBase64 = file => new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => resolve(reader.result)
            reader.onerror = error => reject(error)
        })

        console.log({...this.convention})

        let message = null
        
        // Validation du justificatif d'identité (commun)
        if (!this.convention.justificatifIdentiteFile && !this.convention.justificatifIdentite) {
            message = "Justificatif d'identité requis"
        }
        // Mandat de délégation obligatoire pour tous les établissements
        else if (!this.convention.mandatDelegationFile && !this.convention.mandatDelegation) {
            message = "Mandat de gestion pour délégation des pouvoirs requis"
        }
        // Validations spécifiques aux établissements de droit public
        else if (this.convention.etablissementType === 'public') {
            if (!this.convention.documentCapaciteFile && !this.convention.documentCapacite) {
                message = "Document attestant de la capacité à engager la personne morale requis"
            }
        }

        // Validations communes
        if (!message) {
            if (!this.convention.justificatifImmatriculationFile && !this.convention.justificatifImmatriculation) {
                message = "Justificatif d'immatriculation requis"
            } else if (!this.convention.justificatifAdresseSiegeFile && !this.convention.justificatifAdresseSiege) {
                message = "Justificatif d'adresse du siège requis"
            }
        }

        if (message) {
            this.$toast.open({ message, type: 'error' })
            return false
        }

        try {
            const convention = {}
            if (this.convention.justificatifIdentiteFile) convention.justificatifIdentite = await toBase64(this.convention.justificatifIdentiteFile);
            
            // Conversion du mandat de délégation (pour établissements privés OU établissements publics avec SDR)
            if (this.convention.mandatDelegationFile) {
                convention.mandatDelegation = await toBase64(this.convention.mandatDelegationFile);
            }
            
            // Conversion pour établissements de droit public
            if (this.convention.etablissementType === 'public') {
                if (this.convention.documentCapaciteFile) convention.documentCapacite = await toBase64(this.convention.documentCapaciteFile);
                if (this.convention.statutsLoiFile) convention.statutsLoi = await toBase64(this.convention.statutsLoiFile);
            }
            
            // Conversions communes
            if (this.convention.justificatifImmatriculationFile) convention.justificatifImmatriculation = await toBase64(this.convention.justificatifImmatriculationFile);
            if (this.convention.justificatifAdresseSiegeFile) convention.justificatifAdresseSiege = await toBase64(this.convention.justificatifAdresseSiegeFile);
            
            // Conversions pour documents optionnels
            if (this.convention.dpStatutsFile) convention.dpStatuts = await toBase64(this.convention.dpStatutsFile);
            if (this.convention.dpDeclarationEngagementFile) convention.dpDeclarationEngagement = await toBase64(this.convention.dpDeclarationEngagementFile);

            console.log(this.convention);

            if (JSON.stringify(convention) !== JSON.stringify({})) {
              await axios.put(`/conventions/${this.hash}`, convention);
              this.$toast.open({ message: 'Les pièces ont bien été téléversées', type: 'success' });
            }
            return true
        } catch (err) {
            console.error(err)
            this.$toast.open({
                message: 'Une erreur est survenue lors du téléversement des pièces',
                type: 'error',
            })
            return false
        }
    },
    submitAttachments() {
      if (this.validateAttachments()) {
        this.$refs.formWizard.nextTab()
      }
    },
    async validateAndSendOtp() {
        try {
            await axios.get(`/conventions/${this.hash}/otp`)
            this.$toast.open({
                message: 'Votre code vous a été envoyé par email',
                type: 'success',
            })
            return true;
        } catch(err) {
            console.error(err);
            return false;
        }
    },
    async validateOtp() {
        this.loadingOverlayActive = true;
        try {
            await axios.post(`/conventions/${this.hash}/otp`, { otp: this.otp })
            this.$toast.open({
                message: 'La convention a bien été signée. Merci !',
                type: 'success',
                duration: 10000,
            })
            this.$router.push({ name: 'entrepriseSignatureTerminee' })
            this.loadingOverlayActive = false;
            return true;
        } catch(err) {
            console.error(err);
            this.loadingOverlayActive = false;
            return false;
        }
    },
  }
}
</script>

<style lang="scss">
.custom-control-inline.custom-radio {
  display: inline-block;
  margin-right: 16px;

  input[type=radio] {
    margin-right: 4px !important;
  }
}
.custom-file-input ~ .custom-file-label::after {
    content: "Parcourir" !important;
}

.hidden_header {
  display: none;
}
</style>